// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { BillToSelectorStyles } from "@insite/content-library/Components/BillToSelector";
import { addressBookStyles } from "@insite/content-library/Widgets/AddressBookOverlay/AddressBook";
import { css } from "styled-components";

const selectorStyle: BillToSelectorStyles = {
    customerSelectorToolbar: {
        wrapper: {
            css: css`
                display: grid;
                grid-template-columns: 1fr auto;
                gap: 10px;
            `,
        },
        searchTextField: {
            cssOverrides: {
                formField: css`
                    grid-area: 1 / 1 / 2 / 3;
                    margin-bottom: 0;
                    flex-basis: 100%;
                    ${xScreen("lte", "sm")} {
                        grid-area: 1 / 1 / 2 / 2;
                    }
                `,
            },
        },
        searchButton: {
            variant: "primary",
            css: css`
                margin-top: 0;
                grid-area: 2 / 1 / 3 / 2;
                white-space: nowrap;
                padding-left: 16px;
                padding-right: 16px;
                width: 100%;

                ${xScreen("lte", "sm")} {
                    margin-top: 0;
                    grid-area: 2 / 1 / 3 / 3;
                }
            `,
        },
        wideHidden: {
            below: "md",
            css: css`
                grid-area: 2 / 2 / 3 / 3;
            `,
        },
        narrowHidden: {
            above: "sm",
            css: css`
                grid-area: 1 / 2 / 2 / 3;
            `,
        },
        wideCreateNewAddressButton: {
            variant: "secondary",
            css: css`
                white-space: nowrap;
                padding-left: 16px;
                padding-right: 16px;
                margin-left: 0;
            `,
        },
        overflowMenu: {
            cssOverrides: {
                wrapper: css`
                    margin-left: 0;
                `,
            },
        },
    },
    customerSelector: {
        customerCard: {
            addressGridItem: { width: 10 },
            address: {
                customerNameText: {
                    css: css`
                        font-weight: ${fontConfig.weight.bold};
                    `,
                },
            },
            editGridItem: { width: 2 },
            editLink: {
                css: css`
                    align-items: flex-start;
                `,
            },
            actionsGridItem: { width: 12 },
            actionsWrapper: {
                css: css`
                    width: 100%;
                `,
            },
            selectButton: {
                css: css`
                    width: 100%;
                `,
            },
        },
        customerCardSelected: {
            addressGridItem: { width: 10 },
            address: {
                customerNameText: {
                    css: css`
                        font-weight: ${fontConfig.weight.bold};
                    `,
                },
            },
            editGridItem: { width: 2 },
            editLink: {
                css: css`
                    align-items: flex-start;
                `,
            },
            actionsGridItem: { width: 12 },
            actionsWrapper: {
                css: css`
                    width: 100%;
                `,
            },
            selectButton: {
                css: css`
                    width: 100%;
                `,
            },
        },
        pagination: {
            cssOverrides: {
                perPageSelect: css`
                    margin-bottom: 10px;
                `,
            },
        },
    },
};

addressBookStyles.billToSelector = {
    ...selectorStyle,
};

addressBookStyles.shipToSelector = {
    ...selectorStyle,
};
